export const URLsForSSO = new Set(['smart/launch', 'oauth2/callback', 'saml/login']);
